import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  actualRole: null, // roles that Auth0/Okta gave
  switchedRole: null, // role selected from dropdown
  isSwitchRoleUser: false, // flag to indicate effective role override
}

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    // Called when user logs in → roles from Auth0 in user-context
    setActualRole(state, action) {
      state.actualRole = action.payload // array of roles
    },

    // Called when user selects a new role in dropdown
    setSwitchedRole(state, action) {
      state.switchedRole = action.payload // array of roles
    },
    setIsSwitchRoleUser(state, action) {
      state.isSwitchRoleUser = action.payload // boolean to know is user can switch roles
    },

    // // Reset dropdown override
    // clearSwitchedRole(state) {
    //   state.switchedRole = null
    //   state.isSwitchRoleUser = false
    // },

    // // clear all roles data
    // clearAllRoles(state) {
    //   state.actualRole = []
    //   state.switchedRole = null
    //   state.isSwitchRoleUser = false
    // },
  },
})

export const {
  setActualRole,
  setSwitchedRole,
  setIsSwitchRoleUser,
  //   clearSwitchedRole,
  //   clearAllRoles,
} = userRoleSlice.actions

export default userRoleSlice.reducer
